import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './predictive-search.scss.js';

const boldString = (str, substr) => {
    const strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, `<strong>${substr}</strong>`);
};
class PredictiveSearch extends s {
    constructor() {
        super(...arguments);
        this.showAllResultsText = '';
        this.searchTerm = '';
        this.predictiveSearches = [];
        this.renderPredictiveSearchItem = (item) => $ `<a class="predictive-search-item" href="${this.searchPageUrl}?q=${item}">${o(boldString(item, this.searchTerm))}</a>`;
    }
    render() {
        return $ `<div class="predictive-search">${this.predictiveSearches.map(item => this.renderPredictiveSearchItem(item))} <a class="show-all-results" href="${this.searchPageUrl}?q=${this.searchTerm}"><span>${this.showAllResultsText} <strong>${this.searchTerm}</strong></span></a></div>`;
    }
}
PredictiveSearch.styles = css_248z;
__decorate([
    e({ type: String })
], PredictiveSearch.prototype, "showAllResultsText", void 0);
__decorate([
    e({ type: String })
], PredictiveSearch.prototype, "searchTerm", void 0);
__decorate([
    e({ type: String })
], PredictiveSearch.prototype, "searchPageUrl", void 0);
__decorate([
    e({ type: Array })
], PredictiveSearch.prototype, "predictiveSearches", void 0);
customElements.define('predictive-search', PredictiveSearch);

export { PredictiveSearch };
